(ns frontend.ui.component.lp-portal.report.tearsheet.basic-information.view
  (:require
   [frontend.ui.component.grid.view :as grid]
   [frontend.ui.component.lp-portal.card.view :refer [card]]
   [frontend.ui.component.lp-portal.text-content.view :as text-content]
   [frontend.ui.component.dynamic-table.view :as dynamic-table]))

(defn basic-information-card
  [{:keys [basic-information-primary basic-information-secondary] :as data} props]
  [card
   {:title "Basic information"}
   [:div
    [dynamic-table/dynamic-stack (:figures basic-information-primary)]
    (text-content/optional-footnote basic-information-primary props)]
   [:div
    [dynamic-table/dynamic-stack (:figures basic-information-secondary)]
    (text-content/optional-footnote basic-information-secondary props)]])
